import axios from 'axios';

const objectUrlToBase64 = async (objectUrl: string): Promise<string> => {
  const { data } = await axios.get(objectUrl, { responseType: 'arraybuffer' });
  return Buffer.from(data).toString('base64');
};

export default objectUrlToBase64;
